var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('de-container',[_c('span',[_vm._v("敬请期待")])])}
var staticRenderFns = []

export { render, staticRenderFns }